import { Box, Button, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

export default function OrderTableOrderIdCell({
  rowData,
  client,
  inspectorFirm,
}: any) {
  const navigate = useNavigate();
  const onOrderIdClick = () => {
    if (client?.id) {
      navigate(
        `/clients/${client?.id}/orders/${rowData?.id}`,
        {
          state: {
            order: rowData,
            breadcrumb: {
              names: {
                [client?.id]: client?.clientName,
                [rowData?.id]: `Order #${rowData?.orderNumber}`,
              },
            },
          },
        }
      );
    } else if (inspectorFirm?.id) {
      navigate(
        `/inspection-firms/${inspectorFirm?.id}/orders/${rowData?.id}`,
        {
          state: {
            order: rowData,
            breadcrumb: {
              names: {
                [inspectorFirm?.id]: inspectorFirm?.displayName,
                [rowData?.id]: `Order #${rowData?.orderNumber}`,
              },
            },
          },
        }
      );
    } else {
      navigate(`/orders/${rowData?.id}`, {
        state: {
          order: rowData,
          breadcrumb: {
            names: {
              [rowData?.id]: `Order #${rowData?.orderNumber}`,
            },
          },
        },
      });
    }
  };
  return (
    <Box>
      <Button sx={{ textTransform: "none" }} onClick={onOrderIdClick}>
        <Typography>{rowData.orderNumber}</Typography>
      </Button>
    </Box>
  );
}
